module.exports = __webpack_public_path__ + "static/shopify_bizum-5047df699a216ad0f283dfa6a31952a1.svg";